import { useState, useEffect } from 'react'
import { DropInformation } from '../../DropInformation/DropInformation'
import { DropZoneProductImg } from '../../DropZoneProductImg/DropZoneProductImg'
import { DropZoneProductVideo } from '../../DropZoneProductVideo/DropZoneProductVideo'
import './ModalAddingMedia.scss'
import { ModalComponent } from '../ModalComponent/ModalComponent'

const ModalAddingMedia = ({ setIsModal, arrImg, arrVideo, setArrImg, setArrVideo, productTemporary, fetchProductAttr }) => {
    const [draggedItem, setDraggedItem] = useState(null);
    const [dropTarget, setDropTarget] = useState(null);
    const [isDrop, setIsDrop] = useState(true)

    const saveImgs = async () => {
        const arr_img = [...document.querySelectorAll('.image')]
        const arr_src = arr_img.map((el) => el.src)
        await setArrImg(arr_src)
    }

    const saveVideos = async () => {
        const arr_video = [...document.querySelectorAll('.video')]
        const arr_src = arr_video.map((el) => el.src)
        await setArrVideo(arr_src)
    }

    const handleDragStart = (e, index, classList) => {
        setIsDrop(false)
        e.dataTransfer.setData('text/plain', index);
        setDraggedItem(index);
        e.currentTarget.classList.add(`dragging-${classList}`);
    };

    const handleDragOver = (e, index) => {
        e.preventDefault();
        setDropTarget(index);
    };

    const handleDrop = (e, index, arr, set, classList) => {
        e.preventDefault();
        const fromIndex = parseInt(e.dataTransfer.getData('text/plain'));
        const toIndex = index;

        if (fromIndex !== toIndex) {
            const newArr = [...arr];
            [newArr[fromIndex], newArr[toIndex]] = [newArr[toIndex], newArr[fromIndex]];
            set(newArr);
        }

        setDraggedItem(null);
        setDropTarget(null);
        e.currentTarget.classList.remove(`drag-over-${classList}`);
        setIsDrop(true)
    };

    const handleDragEnd = (e, classList) => {
        e.currentTarget.classList.remove(`dragging-${classList}`);
        setDraggedItem(null);
        setDropTarget(null);
    };

    const handleDragEnter = (e, index, classList) => {
        e.preventDefault();
        e.currentTarget.classList.add(`drag-over-${classList}`);
    };

    const handleDragLeave = (e, classList) => {
        e.currentTarget.classList.remove(`drag-over-${classList}`);
    };

    const saveCallback = () => {
        saveImgs();
    }

    const saveCallbackVideo = () => {
        saveVideos();
    }


    return (
        <ModalComponent
            title='Добавление медиафайлов'
            onClose={e => setIsModal(false)}
            style={{
                height: 'auto',
                maxWidth: '800px'
            }}
            child={
                <div className='modal-adding-media'>
                    <div className='modal-adding-media__content'>
                        <div className='photo-container'>
                            <h5 className='title'>Фотографии</h5>
                            <div className='photo-container__content'>
                                {[...Array((arrImg?.length < 15) ? arrImg?.length + 1 : 15)].map((_, index) => (
                                    <div
                                        key={`img-${index}` + (arrImg[index] || index)}
                                        className={`file-box ${(index == 0 && arrImg[index]) ? `file-box_big` : ''}`}
                                        draggable={index < arrImg?.length}
                                        onDragStart={(e) => handleDragStart(e, index, 'photo')}
                                        onDragOver={(e) => handleDragOver(e, index, 'photo')}
                                        onDrop={(e) => {
                                            if (index < arrImg?.length) {
                                                handleDrop(e, index, arrImg, setArrImg, 'photo')
                                            }
                                            setDraggedItem(null);
                                            setDropTarget(null);
                                            e.currentTarget.classList.remove(`drag-over-photo`);
                                        }}
                                        onDragEnd={(e) => handleDragEnd(e, index, 'photo')}
                                        onDragEnter={(e) => handleDragEnter(e, index, 'photo')}
                                        onDragLeave={(e) => handleDragLeave(e, 'photo')}
                                    >
                                        <DropZoneProductImg
                                            key={index + (arrImg[index] || index)}
                                            handleChangeItemPlace={() => { }}
                                            fetchProductAttr={fetchProductAttr}
                                            setArrImg={setArrImg}
                                            arrImg={arrImg}
                                            ind={index}
                                            saveCallback={saveCallbackVideo}
                                            isDrop={isDrop}
                                        />
                                    </div>
                                ))}
                            </div>
                        </div>

                        <div className='video-container'>
                            <h5 className='title'>Видео</h5>
                            <div className='video-container__content'>
                                {arrVideo?.length < 6 && [...Array((arrVideo?.length < 5) ? arrVideo?.length + 1 : 5)].map((_, index) => (
                                    <div
                                        key={`video-${index}` + (arrVideo[index] || index)}
                                        className={`file-box`}
                                        draggable={index < arrVideo?.length}
                                        onDragStart={(e) => handleDragStart(e, index, 'video')}
                                        onDragOver={(e) => handleDragOver(e, index, 'video')}
                                        onDrop={(e) => {
                                            if (index < arrVideo?.length) {
                                                handleDrop(e, index, arrVideo, setArrVideo, 'video')
                                            }
                                            setDraggedItem(null);
                                            setDropTarget(null);
                                            e.currentTarget.classList.remove(`drag-over-video`);
                                        }}
                                        onDragEnd={(e) => handleDragEnd(e, index, 'video')}
                                        onDragEnter={(e) => handleDragEnter(e, index, 'video')}
                                        onDragLeave={(e) => handleDragLeave(e, 'video')}
                                    >
                                        <DropZoneProductVideo
                                            key={index + (arrVideo[index] || index)}
                                            handleChangeItemPlace={() => { }}
                                            fetchProductAttr={fetchProductAttr}
                                            setArrVideo={setArrVideo}
                                            arrVideo={arrVideo}
                                            ind={index}
                                            saveCallback={saveCallback}
                                            isDrop={isDrop}
                                        />
                                    </div>
                                ))}
                                {/* {[...Array(5)].map((_, index) => (
                                <DropZoneProductVideo
                                    key={`video-${index}`}
                                    arrVideo={currentArrVideo()}
                                    setArrVideo={setArrVideo}
                                    ind={index}
                                />
                            ))} */}
                            </div>
                        </div>

                        <div className='drop-content'>
                            <DropInformation
                                title='Требования к фото'
                                text={<p>Формат: JPEG, JPG, PNG;<br />
                                    Разрешение: от 200px до 7680px по большей стороне;<br />
                                    Размер: не более 10 МБ;<br />
                                    Фон: белый или светлый, для белых или прозрачных товаров — чёрный, для категории Одежда, обувь и аксессуары — серый #f2f3f5;<br />
                                    Соотношение сторон: 3:4 для категорий Одежда, обувь и аксессуары, 1:1 — для остальных.</p>}
                            />

                            <DropInformation
                                title='Требования к видео'
                                text={<p>Формат: MP4, MOV;<br />
                                    Длительность: до 30 секунд;<br />
                                    Разрешение: не менее 720p;<br />
                                    Размер: не более 50 МБ;<br />
                                    Фон: белый или светлый.</p>}
                            />
                        </div>
                    </div>

                    {/* <div className='btn-group'>
                    <ButtonBasic
                        lilac
                        text='Отмена'
                        size='56px'
                        minWidth='93px'
                        maxWidth='93px'
                        width='93px'
                        onClick={() => setIsModal(false)}
                    />
                    <ButtonBasic
                        violet
                        text='Сохранить'
                        onClick={saveCallback}
                        size='56px'
                        width='163px'
                    />
                </div> */}
                </div>
            }
        />
    )
}

export { ModalAddingMedia }